import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

// Define the store's state and actions
interface AuthState {
    username: string;
    userId: number;
    currentRoleId: number,    
    permissionRecord: null,
    currentuserroleList:any[],
    financialYearList : any[],
    currentFinancialYearId :number,
    // rememberMe: boolean;
    // accessToken: string;
    // idtoken: string;
    redirectUrlPostLogin: string | null;
    // Jwtaccesstoken: string;
    // Jwtrefershtoken: string;
    setzustandUsername: (name: string, Id: number, currentRoleId: number, 
        permissionRecord:any,currentuserroleList:any, financialYearList : any
         ) => void;
        setzustandFinancialYearDetails:(currentFinancialYearId :number)=> void;
    // setRememberMe: (value: boolean) => void;
    // setAccessToken: (token: string) => void;
    // setIdToken: (token: string) => void;
    logout: () => void;
    setredirectUrlPostLogin: (url: string | null) => void;
    // setJWTAccessToken: (token: string) => void;
    // setJWTRefreshToken: (token: string) => void;

}

interface AuthStateWithoutPersist {
    JwtaccesstokenDev: string;
    setJWTAccessTokenDev: (token: string) => void;
}

const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            username: '',
            userId: 0,
            currentRoleId: 0,
            permissionRecord: null,
            currentuserroleList:null,
            financialYearList : null,
            currentFinancialYearId :0,
            // rememberMe: false,
            // accessToken: '',
            // idtoken: '',
            redirectUrlPostLogin: null,
            // Jwtaccesstoken: '',
            // Jwtrefershtoken: '',

            setzustandUsername: (name: string, Id: number, currentRoleId: number, 
                permissionRecord:any, currentuserroleList:any,financialYearList : any
                ) => 
                set({ username: name, userId: Id, 
                    currentRoleId: currentRoleId, permissionRecord: permissionRecord,
                    currentuserroleList:currentuserroleList,
                    financialYearList : financialYearList
                     }),

            setzustandFinancialYearDetails: (
                        currentFinancialYearId :number) => 
                        set({ 
                            currentFinancialYearId : currentFinancialYearId }),

            // setRememberMe: (value: boolean) => set({ rememberMe: value }),
            // setAccessToken: (value: string) => set({ accessToken: value }),
            // setIdToken: (value: string) => set({ idtoken: value }),
            setredirectUrlPostLogin: (url: string | null) => set({ redirectUrlPostLogin: url }),
            // setJWTAccessToken: (token: string) => set({ Jwtaccesstoken: token }),
            // setJWTRefreshToken: (token: string) => set({ Jwtrefershtoken: token }),

            logout: () => //set({ username: '', redirectUrlPostLogin: null }), // rememberMe: false, idtoken: '', accessToken: '', externalUrl: null, Jwtaccesstoken: '', Jwtrefershtoken: '' 
            set({ username: '', userId:0, 
                currentRoleId: 0, permissionRecord: null,
                currentuserroleList:null,
                financialYearList : null,redirectUrlPostLogin: null
                 }),
        }),
        {
            name: 'auth-storage', // Stored in localStorage
            storage: createJSONStorage(() => localStorage), // Use createJSONStorage for compatibility
        }
    )
);


const useNonPersistAuthStore = create<AuthStateWithoutPersist>((set) => ({
    JwtaccesstokenDev: '',

    setJWTAccessTokenDev: (token: string) => set({ JwtaccesstokenDev: token }),

}));

export  {useAuthStore, useNonPersistAuthStore};
